import React, { useState } from 'react';
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';

interface Props { onSuccess: () => void; }

const AdminLoginPage: React.FC<Props> = ({ onSuccess }) => {
  const [login,    setLogin]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post<{ token: string }>(`${baseURL}/admin/login`, { login, password });
      localStorage.setItem('admin_token', data.token);
      onSuccess();
    } catch {
      setError('Invalid login or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: 'var(--app-h)', background: 'var(--body-gradient)',
      fontFamily: '"DM Sans", system-ui, sans-serif',
    }}>
      <div style={{
        width: 360, padding: '32px',
        background: 'var(--glass-bg)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
        border: '1px solid var(--glass-border)', borderRadius: 16,
        boxShadow: '0 20px 60px rgba(0,0,0,.4)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 10, flexShrink: 0,
            background: 'linear-gradient(135deg, var(--accent), var(--accent-light))',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: 14, boxShadow: '0 4px 12px var(--accent-glow)',
          }}>▶</div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)' }}>PromoVideo</div>
            <div style={{ fontSize: 11, color: 'var(--text-disabled)' }}>Admin Panel</div>
          </div>
        </div>

        <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 6 }}>Sign in</div>
        <div style={{ fontSize: 13, color: 'var(--text-disabled)', marginBottom: 24 }}>Admin access only</div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <input
            type="text" placeholder="Login" value={login} autoComplete="username"
            onChange={e => setLogin(e.target.value)}
            style={{ background: 'var(--input-bg)', border: '1px solid var(--input-border)', borderRadius: 8, padding: '10px 12px', fontSize: 13, color: 'var(--text-primary)', outline: 'none', fontFamily: 'inherit' }}
          />
          <input
            type="password" placeholder="Password" value={password} autoComplete="current-password"
            onChange={e => setPassword(e.target.value)}
            style={{ background: 'var(--input-bg)', border: '1px solid var(--input-border)', borderRadius: 8, padding: '10px 12px', fontSize: 13, color: 'var(--text-primary)', outline: 'none', fontFamily: 'inherit' }}
          />

          {error && (
            <div style={{ fontSize: 12, color: '#f87171', padding: '8px 12px', background: 'rgba(248,113,113,.08)', border: '1px solid rgba(248,113,113,.2)', borderRadius: 8 }}>
              {error}
            </div>
          )}

          <button type="submit" disabled={loading || !login || !password}
            style={{ marginTop: 4, padding: '10px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, var(--accent), var(--accent-light))', color: '#fff', fontSize: 13, fontWeight: 600, cursor: loading ? 'default' : 'pointer', opacity: loading || !login || !password ? 0.6 : 1, fontFamily: 'inherit', boxShadow: '0 2px 8px var(--accent-glow)' }}
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
